<template>
  <v-card>
    <v-toolbar flat dense color="secondary" dark>
      <v-toolbar-title v-if="title">
        {{ title }}
      </v-toolbar-title>
      <v-spacer />
      <div class="caption">
        <v-icon>trending_up</v-icon>
      </div>
    </v-toolbar>
    <v-card-text class="white--text pt-0">
      <e-chart
        v-if="data && data.length"
        :path-option="defaultOption"
        height="500px"
        :width="width"
      />
    </v-card-text>
  </v-card>
</template>

<script>
import EChart from '@/components/chart/echart'

export default {
  components: {
    EChart,
  },
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    title: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      width: '99%',
    }
  },
  computed: {
    defaultOption() {
      return [
        ['dataset.source', this.data],
        ['legend.show', true],
        ['legend.bottom', '0'],
        // ['color', ['#4572a7', '#93a9cf', '#ff5252']],
        ['xAxis.show', false],
        ['yAxis.show', false],
        ['series[0].type', 'pie'],
        ['series[0].avoidLabelOverlap', false],
        ['series[0].radius', ['40%', '60%']],
      ]
    },
  },
  watch: {
    data() {
      this.resize()
    },
  },
  mounted() {
    this.resize()
  },
  methods: {
    resize() {
      this.width = '99%'
      let vm = this
      setTimeout(() => {
        vm.width = '100%'
      }, 1000)
    },
  },
}
</script>

<style></style>
